var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 77 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 47.789V1l25.005 11.94v13.898M20.387 76.257 1 66.997V47.79M26.004 59.023v19.914l-5.617-2.68M51.012 21.494V1l4.672 2.232.818.39 14.272 6.829 5.228 2.497v65.997l-24.99-11.948V52.56",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M51.001 21.494V1L26.004 12.94v13.898M51.001 52.559v14.437l-24.997 11.94V59.022M64.26 50.335l-.975-1.294M60.879 45.822l-7.14-9.534c-2.243-2.995-6.203-3.526-9.03-1.22L31.584 45.78c-3.038 2.481-7.335 1.651-9.435-1.825l-8.34-13.865",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.199 26.655c-1.568.564-3.225-.29-3.705-1.908-.48-1.618.405-3.394 1.972-3.958 1.568-.564 3.225.29 3.705 1.908.48 1.618-.405 3.394-1.972 3.958Z",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m68.867 55.348-5.527 6.115M63.34 55.348l5.527 6.115",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgMap;